/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

import template from './elections-list-page.component.html';
import {ElectionResource} from '../../../components/api/resources/resource/election.resource';
import {createBufferedFlag, readBufferedFlag} from '../../common/util/template-state';

function isCurrentElection(election: any): boolean {
  if (!election.electionDate) {
    return true;
  }

  return moment(election.electionDate).startOf('day').isSameOrAfter(moment().startOf('day'));
}

function sortElections(elections: any[]): any[] {
  return _.orderBy(elections || [], [
    function(election) {
      return election.electionDate ? 0 : 1;
    },
    'electionDate',
    function(election) {
      return (election.name || '').toLowerCase();
    }
  ]);
}

@Component({
  standalone: false,
  selector: 'adn-elections-list-page',
  template
})
export class ElectionsListPageComponent implements OnInit, OnDestroy {
  loaded = false;
  private readonly loadedFlag = createBufferedFlag();
  private destroyed = false;
  includeTestOnly = false;
  showPastElections = false;
  allElections: any[] = [];
  elections: any[] = [];

  constructor(
    @Inject(ElectionResource) private readonly Election: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  get displayLoaded(): boolean {
    return readBufferedFlag(this.loadedFlag, this.loaded, this.cdr, () => !this.destroyed);
  }

  ngOnInit(): void {
    this.loadElections();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  applyFilters(): void {
    this.elections = sortElections(_.filter(this.allElections, (election) => {
      if (!this.includeTestOnly && election.testOnly) {
        return false;
      }
      if (!this.showPastElections && !isCurrentElection(election)) {
        return false;
      }
      return true;
    }));
  }

  loadElections(): void {
    this.loaded = false;

    this.Election.get({includeTests: true}).$promise.then((data: any) => {
      this.allElections = data.results || [];
      this.applyFilters();
      this.loaded = true;
    }, () => {
      this.allElections = [];
      this.elections = [];
      this.loaded = true;
    });
  }
}
